let ctx;
const ac = () => { try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); if (ctx.state === "suspended") ctx.resume(); return ctx; } catch { return null; } };

function tone(freq, dur = 0.12, type = "sine", vol = 0.15, when = 0) {
  const c = ac(); if (!c) return;
  const o = c.createOscillator(); const g = c.createGain();
  o.type = type; o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, c.currentTime + when);
  g.gain.exponentialRampToValueAtTime(vol, c.currentTime + when + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + when + dur);
  o.connect(g); g.connect(c.destination); o.start(c.currentTime + when); o.stop(c.currentTime + when + dur + 0.02);
}
function noise(dur = 0.08, vol = 0.12) {
  const c = ac(); if (!c) return;
  const b = c.createBuffer(1, c.sampleRate * dur, c.sampleRate); const d = b.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const s = c.createBufferSource(); s.buffer = b; const g = c.createGain(); g.gain.value = vol; s.connect(g); g.connect(c.destination); s.start();
}

export const SFX = {
  deal: () => { noise(0.06, 0.1); tone(900, 0.05, "triangle", 0.05, 0.03); },
  chips: () => { tone(1800, 0.04, "square", 0.04); tone(2200, 0.04, "square", 0.04, 0.05); tone(2600, 0.05, "square", 0.04, 0.1); },
  raise: () => { tone(500, 0.08, "sawtooth", 0.08); tone(750, 0.12, "sawtooth", 0.08, 0.08); },
  check: () => tone(400, 0.06, "sine", 0.1),
  fold: () => { noise(0.05, 0.06); tone(220, 0.15, "sine", 0.08); },
  win: () => [523, 659, 784, 1046].forEach((f, i) => tone(f, 0.25, "triangle", 0.12, i * 0.09)),
  turn: () => { tone(880, 0.08, "sine", 0.12); tone(1320, 0.1, "sine", 0.1, 0.1); },
  tick: () => tone(1200, 0.03, "square", 0.05),
  tile: () => { noise(0.04, 0.15); tone(300, 0.06, "triangle", 0.1); },
  pass: () => tone(260, 0.2, "sine", 0.08),
  sit: () => tone(660, 0.1, "sine", 0.08),
  leave: () => tone(330, 0.15, "sine", 0.08),
};
export const play = (name) => { try { SFX[name]?.(); } catch (e) { console.debug("sfx", e); } };
